var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPauseRoundedBorders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "2p8be6jyya"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D6870",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90A0AB",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 1.92C6.442 1.92 1.92 6.442 1.92 12S6.442 22.08 12 22.08 22.08 17.558 22.08 12 17.558 1.92 12 1.92zM9.77 6.14a1.2 1.2 0 0 1 1.2 1.2v9.12a1.2 1.2 0 1 1-2.4 0V7.34a1.2 1.2 0 0 1 1.2-1.2zm4.8 0a1.2 1.2 0 0 1 1.2 1.2v9.12a1.2 1.2 0 1 1-2.4 0V7.34a1.2 1.2 0 0 1 1.2-1.2z",
    fill: "url(#2p8be6jyya)",
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseRoundedBorders);
export default __webpack_public_path__ + "static/media/pause-rounded-borders.f9980d8ec4e35d6202d28915f68a8cac.svg";
export { ForwardRef as ReactComponent };